module.exports = __webpack_public_path__ + "img/JMWLP_studio-page-banner@2x.10f3a20e.jpg";